import { useTranslation } from '@refinedev/core';
import { ClaimActionConfirmDialogModal } from './ClaimActionConfirmDialogModal';

interface ClaimBulkCancelModalProps {
  open: boolean;
  claimCount: number;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

export const ClaimBulkCancelModal = ({
  open,
  claimCount,
  onClose,
  onConfirm,
}: ClaimBulkCancelModalProps) => {
  const { translate } = useTranslation();

  return (
    <ClaimActionConfirmDialogModal
      open={open}
      setOpen={(isOpen) => {
        if (!isOpen) onClose();
      }}
      onConfirm={onConfirm}
      title={translate(
        'pages:claims.bulkCancel.title',
        'Cancel selected claims'
      )}
      body={translate('pages:claims.bulkCancel.body', {
        count: claimCount,
        defaultValue:
          'Are you sure you want to cancel {{count}} selected claim?',
      })}
      emphasizePhrase={translate(
        'pages:claims.bulkCancel.emphasizePhrase',
        'cancel'
      )}
      cancelText={translate(
        'pages:claims.bulkCancel.cancelText',
        'Back to Safety'
      )}
      confirmText={translate(
        'pages:claims.bulkCancel.confirmText',
        'Cancel Claims'
      )}
      confirmButtonColor="red-dark"
    />
  );
};
